import React, { useRef } from "react";
import { useFormReact } from "../../hooks/useFormReact";
import {
	SiWhatsapp,
	SiTelegram,
	SiGmail,
	SiMicrosoftoutlook,
} from "react-icons/si";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

import cv from "../../assets/Kevin/noun-cv-1084868.svg";

export const ContactForm = () => {
	const [formValues, handleInputChange, reset] = useFormReact({
		NamePerson: "",
		LastNamePerson: "",
		email: "",
		phone: "",
		BodyMsg: "",
	});

	const formRef = useRef();
	const { NamePerson, LastNamePerson, email, phone, BodyMsg } = formValues;

	const handleSubmit = (e) => {
		e.preventDefault();

		emailjs
			.sendForm(
				"service_c3281gk",
				"template_jj5863e",
				formRef.current,
				"Lt81zzperaGitvJC0"
			)
			.then((result) => {
				Swal.fire(result.text, "Correo Enviado exitosamente", "success");
			})
			.catch((error) => {
				console.log(error.text);
			});

		// console.log(e.target);
		setTimeout(() => {
			reset();
		}, 200);
	};

	const { t, i18n } = useTranslation("global");
	return (
		<>
			<div className="mt-20 -mb-14 select-none transition-all duration-500 ease-linear overflow-hidden">
				<section className="content-image2 transition-all duration-500 ease-linear">
					<div className="flex items-center justify-between root flex-col lg:flex-row">
						{
							<div className="bg-white shadow-2xl rounded-3xl lg:mx-8 lg:my-5 lg:w-2/3 w-11/12 text-sm">
								<form
									className="grid grid-cols-3 gap-4 mx-8 my-6"
									onSubmit={handleSubmit}
									ref={formRef}
								>
									<div className="grid grid-cols-1 gap-4">
										<label className="text-gray-600 font-Montserrat font-medium">
											{t("name")}:
										</label>
										<label className="text-gray-600 font-Montserrat font-medium">
											{t("last-name")}:
										</label>
										<label className="text-gray-600 font-Montserrat font-medium">
											{t("personal-email")}:
										</label>
										<label className="text-gray-600 font-Montserrat font-medium">
											{t("phone")}:
										</label>
										<label className="text-gray-600 font-Montserrat font-medium">
											{t("message")}:
										</label>
									</div>

									<div className="grid grid-cols-1 gap-4 col-span-2">
										<input
											type="text"
											className="bg-gray-200 w-full h-10 px-5 outline-none font-Poppins font-medium text-gray-700"
											placeholder="Mateo"
											required={true}
											name="NamePerson"
											value={NamePerson}
											onChange={handleInputChange}
										/>
										<input
											type="text"
											className="bg-gray-200 w-full h-10 px-5 outline-none font-Poppins font-medium text-gray-700"
											placeholder="García"
											required={true}
											name="LastNamePerson"
											value={LastNamePerson}
											onChange={handleInputChange}
										/>
										<input
											type="email"
											className="bg-gray-200 w-full h-10 px-5 outline-none font-Poppins font-medium text-gray-700"
											placeholder="mateo@example.com"
											required={true}
											name="email"
											value={email}
											onChange={handleInputChange}
										/>
										<input
											type="text"
											className="bg-gray-200 w-full h-10 px-5 outline-none font-Poppins font-medium text-gray-700"
											placeholder="+505 - #### ####"
											name="phone"
											value={phone}
											onChange={handleInputChange}
										/>
										<textarea
											className="bg-gray-200 w-full resize-none h-28 px-5 py-2 outline-none font-Poppins font-medium text-gray-700"
											required={true}
											placeholder="Charlemos acerca de algún proyecto o necesidad en la cual requieres de mis servicios"
											name="BodyMsg"
											value={BodyMsg}
											onChange={handleInputChange}
										></textarea>
									</div>

									<div>
										<input
											value={t("send")}
											type="submit"
											onClick={handleSubmit}
											className="outline-none py-2 px-5 bg-blue-700 text-white rounded-xl cursor-pointer font-Poppins font-medium"
										/>
									</div>
								</form>
							</div>
						}
						<br />
						<div className="flex flex-col">
							<div className="flex flex-col justify-center items-center my-4">
								<p className="font-Poppins font-medium text-lg text-gray-500">
									{t("contact-info")}
								</p>

								<div className="flex justify-center items-center">
									<a
										href="mailto:gkevinyamil@gmail.com?Subject=Contacto%20a%20raíz%20del%20portafolio"
										target="_blank"
										rel="noreferrer"
									>
										<SiGmail className="cursor-pointer bg-red-400 text-white rounded-xl p-1 text-4xl mx-3" />
									</a>

									<a
										href="mailto:gkevinyamil@outlook.com?Subject=Contacto%20a%20raíz%20del%20portafolio"
										target="_blank"
										rel="noreferrer"
									>
										<SiMicrosoftoutlook className="cursor-pointer bg-blue-600 text-white rounded-xl p-1 text-4xl mx-3" />
									</a>
								</div>
							</div>
							<div className="flex flex-col justify-center items-center my-4">
								<p className="font-Poppins font-medium text-lg text-gray-500">
									{t("contact-info-2")}
								</p>
								<div className="flex justify-center items-center">
									<a
										href="https://api.whatsapp.com/send?phone=+505-82230224&text=hola%20que%20tal"
										target="_blank"
										rel="noreferrer"
									>
										<SiWhatsapp className="cursor-pointer bg-green-400 text-white rounded-xl p-1 text-4xl mx-3" />
									</a>
									<a
										href="https://t.me/+-ZhO99WxvdQyOWZh"
										target="_blank"
										rel="noreferrer"
									>
										<SiTelegram className="cursor-pointer bg-blue-400 text-white rounded-xl p-1 text-4xl mx-3" />
									</a>
								</div>
								<br />
								<p className="font-Poppins font-medium text-1s text-lg text-gray-500">
									{t("contact-info-3")}
								</p>
							</div>
						</div>
					</div>

					<div className="flex flex-col items-center justify-center">
						<div className="root mt-16 text-center font-bold text-xl text-gray-800 my-5 font-Montserrat">
							<h2>{t("talk")}</h2>
							<div className="section-title"></div>
							<br />
							<p className="font-Poppins font-medium text-lg text-gray-500">
								{t("talk-info")}
								<br />
								{t("talk-info-2")}
							</p>
							<br />
							<br />
							<div
								className="left-1/4 relative outline-none py-2 px-5 w-1/2 bg-blue-700 text-white rounded-xl cursor-pointer font-Poppins font-medium flex justify-center items-center hover:shadow-lg"
								onClick={() =>
									window.open(
										i18n.changeLanguage === "es"
											? "https://firebasestorage.googleapis.com/v0/b/react-apps-8a09f.appspot.com/o/CV%20-%20ESP.pdf?alt=media&token=1c1341c8-7760-468e-8d0d-98bd2ed00477"
											: "https://firebasestorage.googleapis.com/v0/b/react-apps-8a09f.appspot.com/o/CV%20-%20ENG.pdf?alt=media&token=950847da-9ab0-4170-9084-020ade7c1209",
										"_blank"
									)
								}
							>
								{" "}
								{t("download-cv")}
								<img loading="lazy" src={cv} className="w-10" alt="cv" />
							</div>
						</div>
					</div>
				</section>
			</div>
		</>
	);
};
